// extracted by mini-css-extract-plugin
export default {"wrap":"PricePeriodSingleComponent_wrap__KUGCM","daysCount":"PricePeriodSingleComponent_daysCount__WOzoX","discount":"PricePeriodSingleComponent_discount__EQAq5"};